module.exports = __webpack_public_path__ + "static/media/icon_play_dark.0f81b899.svg";